var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 366,
    viewBox: "0 0 401 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.352 332.752L507.434 326.832C456.776 250.337 420.823 165.056 401.421 75.3672V75.3672",
    stroke: "url(#paint0_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.958 344.539L477.592 338.277C433.977 257.523 405.808 169.332 394.532 78.2354V78.2354",
    stroke: "url(#paint1_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M449.747 353.405L446.934 346.854C410.751 262.535 390.591 172.208 387.485 80.4976V80.4976",
    stroke: "url(#paint2_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M417.64 359.482L415.432 352.72C386.928 265.491 374.943 173.705 380.094 82.0759V82.0759",
    stroke: "url(#paint3_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M385.229 362.666L383.625 355.72C363.065 266.292 359.356 173.812 372.687 83.0234V83.0234",
    stroke: "url(#paint4_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352.651 362.954L351.678 355.904C339.22 264.987 343.812 172.544 365.219 83.3123V83.3123",
    stroke: "url(#paint5_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.197 360.323L319.855 353.219C315.572 261.538 328.412 169.862 357.717 82.8906V82.8906",
    stroke: "url(#paint6_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.093 354.72L288.408 347.616C292.362 255.957 313.37 165.841 350.355 81.8916V81.8916",
    stroke: "url(#paint7_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.629 346.301L257.576 339.25C269.726 248.291 298.724 160.397 343.081 80.0767V80.0767",
    stroke: "url(#paint8_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M226.045 335.092L227.622 328.146C247.872 238.65 284.628 153.718 336.002 77.7075V77.7075",
    stroke: "url(#paint9_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.599 321.201L198.782 314.413C226.96 227.095 271.17 145.803 329.143 74.7083V74.7083",
    stroke: "url(#paint10_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M168.413 304.705L171.2 298.154C207.098 213.718 258.414 136.719 322.517 71.104V71.104",
    stroke: "url(#paint11_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142.118 285.762L145.484 279.501C188.804 198.625 246.806 126.535 316.52 66.9211V66.9211",
    stroke: "url(#paint12_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.271 264.532L121.083 258.586C171.44 181.923 235.64 115.327 310.393 62.2129V62.2129",
    stroke: "url(#paint13_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5813 241.169L98.9985 235.592C156.023 163.755 225.929 103.182 305.136 56.9775V56.9775",
    stroke: "url(#paint14_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0713 215.832L78.9618 210.571C142.217 144.125 217.306 90.0732 300.376 51.1885V51.1885",
    stroke: "url(#paint15_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8981 188.785L61.1567 184.102C130.117 123.608 209.742 76.5076 295.954 45.2146V45.2146",
    stroke: "url(#paint16_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2321 160.213L45.9902 156.03C120.085 101.96 203.609 62.1929 292.277 38.7693V38.7693",
    stroke: "url(#paint17_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1914 130.353L33.2914 126.696C111.931 79.4799 198.683 47.3591 289.097 31.9822V31.9822",
    stroke: "url(#paint18_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8812 99.4394L23.2704 96.3349C105.835 56.3901 195.117 32.1932 286.543 24.9839V24.9839",
    stroke: "url(#paint19_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36377 67.7366L16.0159 65.1057C101.832 32.7505 192.926 16.6904 284.626 17.7488V17.7488",
    stroke: "url(#paint20_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7334 35.4822L11.5696 33.5616C99.9345 9.021 192.095 1.16961 283.335 10.4094V10.4094",
    stroke: "url(#paint21_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.9359L9.99395 1.64673C100.196 -14.8972 192.69 -14.46 282.732 2.9359V2.9359",
    stroke: "url(#paint22_linear_674_2498)",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_674_2498",
    x1: 409.822,
    y1: 103.676,
    x2: 543.958,
    y2: 129.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_674_2498",
    x1: 401.137,
    y1: 107.526,
    x2: 508.214,
    y2: 123.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_674_2498",
    x1: 392.243,
    y1: 110.514,
    x2: 470.212,
    y2: 118.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_674_2498",
    x1: 381.889,
    y1: 112.587,
    x2: 430.684,
    y2: 115.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_674_2498",
    x1: 366.411,
    y1: 113.781,
    x2: 392.169,
    y2: 114.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_674_2498",
    x1: 346.397,
    y1: 114.07,
    x2: 372.161,
    y2: 114.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_674_2498",
    x1: 322.005,
    y1: 113.405,
    x2: 370.748,
    y2: 116.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_674_2498",
    x1: 292.851,
    y1: 111.9,
    x2: 370.819,
    y2: 119.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_674_2498",
    x1: 263.236,
    y1: 109.358,
    x2: 370.343,
    y2: 125.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_674_2498",
    x1: 234.448,
    y1: 106.017,
    x2: 368.614,
    y2: 131.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_674_2498",
    x1: 206.728,
    y1: 101.82,
    x2: 365.134,
    y2: 140.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_674_2498",
    x1: 180.19,
    y1: 96.7974,
    x2: 359.326,
    y2: 150.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_674_2498",
    x1: 155.446,
    y1: 90.9911,
    x2: 350.864,
    y2: 161.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_674_2498",
    x1: 132.03,
    y1: 84.4656,
    x2: 338.155,
    y2: 173.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_674_2498",
    x1: 110.672,
    y1: 77.2365,
    x2: 321.094,
    y2: 185.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_674_2498",
    x1: 91.3657,
    y1: 69.2974,
    x2: 298.139,
    y2: 197.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_674_2498",
    x1: 74.2434,
    y1: 61.0057,
    x2: 267.766,
    y2: 207.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_674_2498",
    x1: 59.4937,
    y1: 52.1267,
    x2: 229.346,
    y2: 211.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_674_2498",
    x1: 47.2065,
    y1: 42.8018,
    x2: 182.778,
    y2: 205.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_674_2498",
    x1: 37.4891,
    y1: 33.1731,
    x2: 130.384,
    y2: 185.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_674_2498",
    x1: 30.3996,
    y1: 23.2032,
    x2: 78.995,
    y2: 143.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_674_2498",
    x1: 26.0244,
    y1: 9.82569,
    x2: 43.6198,
    y2: 86.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_674_2498",
    x1: 24.3775,
    y1: -8.97267,
    x2: 28.307,
    y2: 28.1177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155473,
    stopColor: "#ADD0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628368,
    stopColor: "#F6C1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE5E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle3);
export default __webpack_public_path__ + "static/media/Circle 3.a8299646a561cffe7291c853ad5dfd58.svg";
export { ForwardRef as ReactComponent };